import { React } from 'react';
import Main from './components/Main'
import CookieBanner01 from './components/CookieBanner01.jsx'
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChiSono from './components/ChiSono';
//import Projects from './components/Projects';

// New Split Components
import About from './components/About';
// import Gallery from './components/Gallery';
import Collaboration from './components/Collaboration';
import DigitalInvite from './components/DigitalInvite';

function App() {

  return (
    <div className="App bg-gradient-to-b from-slate-100 to-gray-50">

      <CookieBanner01 />
      <Navbar />

      <section id="home">
        <Main />
      </section>

      {/* 1. Philosophy / Intro */}
      <section id="about">
        <About />
      </section>

      {/* 2. Portfolio / The Main Product Case Study */}
      <section id="invite">
        <DigitalInvite />
      </section>

      {/* 3. Visual Reinforcement */}
      {/* <section id="gallery">
        <Gallery />
      </section> */}

      {/* 4. Call To Action / Collaboration */}
      <section id="collaboration">
        <Collaboration />
      </section>

      {/* <section id="projects">
        <Projects />
      </section> */}

      <section id="chisono">
        <ChiSono />
      </section>

      <Footer />
    </div>
  );
}

export default App;
